/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CloudAccountMini
 */
export interface CloudAccountMini {
    /**
     * 
     * @type {number}
     * @memberof CloudAccountMini
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof CloudAccountMini
     */
    provider?: CloudAccountMiniProviderEnum;
    /**
     * 
     * @type {string}
     * @memberof CloudAccountMini
     */
    name: string;
}

/**
* @export
* @enum {string}
*/
export enum CloudAccountMiniProviderEnum {
    Azure = 'azure',
    Aws = 'aws',
    Backblaze = 'backblaze',
    Gcloud = 'gcloud'
}

export function CloudAccountMiniFromJSON(json: any): CloudAccountMini {
    return CloudAccountMiniFromJSONTyped(json, false);
}

export function CloudAccountMiniFromJSONTyped(json: any, ignoreDiscriminator: boolean): CloudAccountMini {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'provider': !exists(json, 'provider') ? undefined : json['provider'],
        'name': json['name'],
    };
}

export function CloudAccountMiniToJSON(value?: CloudAccountMini | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'provider': value.provider,
        'name': value.name,
    };
}


